import { Chart } from 'primereact/chart'
import React from 'react'

const ChartBarComp = ({ chartData, chartOptions }) => {
  return <Chart type="bar" data={chartData} options={chartOptions} />
}

export default ChartBarComp
